import { useState } from "react";

// Redux

// Services
import { getTranslateByKey } from "@/main/services/utils";

// Types

// Api

// Components
import KOGSection from "@/main/components/shared/kogSection/kogSection";

import { DynamicReportForm, DynamicReportPermissionForm } from "../../registerDynamicReport";
import { FieldArrayWithId, useFieldArray, useFormContext } from "react-hook-form";
import NewPermission from "./newPermission/newPermission";
import PermissionList from "./PermissionList/permissionList";

function PermissionsSection() {
	const [permissionToEdit, setPermissionToEdit] = useState<FieldArrayWithId<
		DynamicReportForm,
		"permissions",
		"id"
	> | null>(null);

	const { control } = useFormContext<DynamicReportForm>();

	const { fields, append, replace } = useFieldArray<DynamicReportForm, "permissions">({ control, name: "permissions" });

	function addNew(newPermission: DynamicReportPermissionForm) {
		append(newPermission);
	}

	function startEdit(permission: FieldArrayWithId<DynamicReportForm, "permissions", "id">) {
		setPermissionToEdit(permission);
	}

	function finishEdit(updatedPermission: DynamicReportPermissionForm | null) {
		if (!permissionToEdit) return;

		if (updatedPermission) {
			const index = fields.findIndex((field) => field.id == permissionToEdit.id);
			if (index > -1) {
				fields[index] = { ...updatedPermission, id: fields[index].id };
				replace(fields);
			}
		}
		setPermissionToEdit(null);
	}

	function removePermission(permission: FieldArrayWithId<DynamicReportForm, "permissions", "id">) {
		const updatedFields = fields.filter((field) => field.id != permission.id);
		replace(updatedFields);
	}

	return (
		<KOGSection title={getTranslateByKey("dynamicReport.permissions")}>
			<NewPermission
				fields={fields}
				permissionToEdit={permissionToEdit as DynamicReportPermissionForm}
				finishEdit={finishEdit}
				addNew={addNew}
			/>
			{!!fields && fields.length > 0 && (
				<PermissionList fields={fields} startEdit={startEdit} remove={removePermission} />
			)}
		</KOGSection>
	);
}

export default PermissionsSection;
